/*
 * FileUploader Messages
 *
 * This contains all the text for the FileUploader component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    levelHeader: {
        id: 'app.components.ExtendResultTable.levelHeader',
        defaultMessage: 'Level'
    },
    keepResultsHeader: {
        id: 'app.components.ExtendResultTable.keepResultsHeader',
        defaultMessage: 'Keep results'
    },
    startFreshHeader: {
        id: 'app.components.ExtendResultTable.startFreshHeader',
        defaultMessage: 'Start fresh'
    }
});



// WEBPACK FOOTER //
// ./app/components/extend-result-table/messages.js